export default __webpack_public_path__ + "source-sans-pro-v11-latin-600-bd652d4188f59c167e3e51f1e6ac85ee.bundle.woff2";